import { makeStyles } from '@mui/styles'

import { defaultPalette } from '../../../theme/idsTheme'

const gutter = 4
const switchHeight = 16 * 1.75
const switchWidth = 16 * 3.25
const thumbWidth = 16 * 1.45 - gutter / 2

const sizes = {
    switchHeight: `${switchHeight}px`,
    switchWidth: `${switchWidth}px`,
    gutter: `${gutter}px`,
    thumbWidth: `${thumbWidth}px`,
    activeThumbLeft: `${switchWidth - thumbWidth - gutter}px`,
}

export default makeStyles(() => ({
    LargeSwitchWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
    },
    LargeSwitchLabel: {},
    LargeSwitch: {
        height: sizes.switchHeight,
        width: sizes.switchWidth,
        padding: 0,
    },
    LargeSwitchBase: {
        padding: 0,
        top: '50%',
        left: gutter,
        transform: 'translateY(-50%)',
        transition: 'left 150ms cubic-bezier(0.4, 0, 0.2, 1)',
        color: defaultPalette.typography.light,
        '&.Mui-checked': {
            left: sizes.activeThumbLeft,
            transform: 'translateY(-50%)',
            color: defaultPalette.primary.main,
        },
    },
    LargeSwitchBaseError: {
        '& .LargeSwitchThumb': {
            color: `${defaultPalette.red.main} !important`,
        },
    },
    LargeSwitchThumb: {
        height: sizes.thumbWidth,
        width: sizes.thumbWidth,
        boxShadow: 'none',
        borderRadius: '100px',
    },
    LargeSwitchTrack: {
        height: '100%',
        borderRadius: '100px',
        backgroundColor: `${defaultPalette.lightGrey.mediumDark} !important`,
        opacity: 1,
    },
    LargeSwitchBaseDisabled: {
        color: defaultPalette.typography.light,
    },
    LargeSwitchThumbDisabled: {
        opacity: `${0.8} !important`,
        color: `${defaultPalette.typography.light} !important`,
    },
    LargeSwitchTrackDisabled: {
        opacity: `${0.8} !important`,
        backgroundColor: defaultPalette.lightGrey.darker,
    },
}))
